import { Component, Input } from '@angular/core';
import { PolicyService } from 'app/services/policy-service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-product-service',
    templateUrl: './product-service.component.html',
    styleUrls: ['./product-service.component.scss']
})
export class ProductServiceComponent {

    @Input() data;
    close: Boolean = false;
    @Input() showDetailsButton: Boolean = false;

    constructor(private policyService: PolicyService, private router: Router, private route: ActivatedRoute) { }

    getIconColor(): any {
        if (undefined !== this.data) {
            return this.data.suspended ? 'red' : 'blue'
        }
    }

    getStatusColor(): any {
        let color = 'black';
        if (undefined !== this.data) {
            color = this.data.suspended ? 'red' : 'black'
        }
        return {
            'color': color
        }
    }

    getBackgroundColor() {
        let color = 'black';
        if (undefined !== this.data) {
            color = this.data.suspended ? 'red' : 'blue'
        }
        return 'background-' + color
    }

    onGetContractFile() {
        this.close = true;
        setTimeout(() => {
            this.close = undefined;
        }, 200);
        this.policyService.getContractFile(this.data.id);
    }

    getServiceOption(expediente, type) {
        this.router.navigate(['/productService/' + expediente + type], { relativeTo: this.route.root });
    }

}
